import { FormFieldInfo, getFormValidationErrors } from './formValidation';

/**
 * Client-side validation for the registration form.
 */
const registrationForm = () => {
	return {
		$refs: {} as {
			form: HTMLFormElement;
			errors: HTMLDivElement;
		},

		invalidFields: [] as FormFieldInfo[],
		submissionAttempted: false,
		isFormValid: false,

		get isErrorsVisible() {
			return this.submissionAttempted && !this.isFormValid;
		},

		checkValid() {
			const { form } = this.$refs;
			if (!form) return false;

			this.invalidFields = getFormValidationErrors(form);
			this.isFormValid = this.invalidFields.length === 0;
		},

		checkPasswordsMatch() {
			const { form } = this.$refs;
			if (!form) return;

			const password = form.elements.namedItem('password') as HTMLInputElement | null;
			const passwordConfirm = form.elements.namedItem(
				'passwordConfirm',
			) as HTMLInputElement | null;
			if (!password || !passwordConfirm) return;

			passwordConfirm.setCustomValidity(
				passwordConfirm.value && passwordConfirm.value !== password.value
					? 'Passwords do not match'
					: '',
			);
		},

		handleValidation(e: Event) {
			this.submissionAttempted = true;
			this.checkValid();

			if (!this.isFormValid) {
				e.stopImmediatePropagation();
			}
		},
	};
};

export default registrationForm;
